import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';

import NewsCard from 'fragments/NewsCard';
import Logo from 'fragments/Logo';
import { RichTextBlock, CustomEmbedBlock } from 'fragments/GenericBlocks';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on NewsPage {
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          socialShareTitle
          body
          bodyRt
          introduction
          optionalBody {
            blockType
            id
            ...RichTextBlock
            ...CustomEmbedBlock
          }
          parent {
            title
            url
          }
          breadcrumbs {
            url
            title
          }
          otherNews {
            ...NewsCard
          }
          image {
            ... on ImageObjectType {
              title
              lg: rendition(fill: "900x280-c100") {
                url
              }
              sm: rendition(fill: "640x150-c100") {
                url
              }
            }
          }
        }
      }
    }
  `,
  {
    NewsCard,
    RichTextBlock,
    CustomEmbedBlock,
    Logo,
  },
);
